(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("throttle-debounce"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "throttle-debounce"], factory);
	else if(typeof exports === 'object')
		exports["EmojiPicker"] = factory(require("react"), require("throttle-debounce"));
	else
		root["EmojiPicker"] = factory(root["react"], root["throttle-debounce"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_58__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition